import { render, staticRenderFns } from "./SparepartsModal.vue?vue&type=template&id=2dcbc43b&scoped=true"
import script from "./SparepartsModal.vue?vue&type=script&lang=ts"
export * from "./SparepartsModal.vue?vue&type=script&lang=ts"
import style0 from "./SparepartsModal.vue?vue&type=style&index=0&id=2dcbc43b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbc43b",
  null
  
)

export default component.exports